import React from 'react';

const RedoSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9 9.3c1.8-.9 3.9-1.1 5.9-.3 1.5.5 2.7 1.5 3.6 2.8V7.5h1v6h-6v-1h4.1c-.8-1.1-1.8-2.1-3.1-2.5-1.7-.6-3.5-.5-5.1.3a7.09 7.09 0 0 0-3.8 6.3h-1c.1-3.2 1.8-6 4.4-7.3"
        />
    </svg>
);

RedoSvg.displayName = 'RedoSvg';
export default RedoSvg;
